/* Sérénelle · le patch qui se décolle (WebGL, sans dépendance) */
(() => {
  'use strict';
  const sec = document.getElementById('lisPatch');
  if (!sec) return;
  const scene = sec.querySelector('.lis-p3d-scene');
  const canvas = sec.querySelector('.lis-p3d-canvas');
  const zone = sec.querySelector('.lis-p3d-texte');
  if (!scene || !canvas || !zone) return;

  const off = () => { sec.classList.remove('lis-p3d-on'); sec.classList.add('lis-p3d-off'); };
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) { off(); return; }

  let gl = null;
  try { gl = canvas.getContext('webgl', { alpha: true, premultipliedAlpha: true, antialias: true }); } catch (e) { gl = null; }
  if (!gl) { off(); return; }

  /* Direction du décollement : le coin haut-gauche se soulève et se rabat vers le bas, dans le sens du défilement. */
  const dir = (x, y) => { const n = Math.hypot(x, y); return [x / n, y / n]; };
  let D = dir(-0.62, -0.78);

  const VS = `
attribute vec2 aUv;
uniform vec2 uCentre, uTaille, uDir, uEcran;
uniform float uL, uR, uF, uRot;
uniform vec3 uDepl;
varying vec2 vUv;
varying vec3 vN;
void main(){
  vUv = aUv;
  vec2 p = (aUv - 0.5) * uTaille;
  float s = dot(p, uDir);
  float d = s - uL;
  float z = 0.0;
  vec3 n = vec3(0.0, 0.0, 1.0);
  if (d > 0.0) {
    float th = d / uR;
    float sn;
    if (th < 3.14159265) {
      sn = uL + uR * sin(th);
      z = uR * (1.0 - cos(th));
      n = vec3(-sin(th) * uDir, cos(th));
    } else {
      sn = uL - (d - 3.14159265 * uR);
      z = 2.0 * uR;
      n = vec3(0.0, 0.0, -1.0);
    }
    p += (sn - s) * uDir;
  }
  float cr = cos(uRot), sr = sin(uRot);
  p = vec2(cr * p.x - sr * p.y, sr * p.x + cr * p.y);
  n.xy = vec2(cr * n.x - sr * n.y, sr * n.x + cr * n.y);
  vec3 w = vec3(p + uCentre + uDepl.xy, z + uDepl.z);
  vN = n;
  float k = uF / max(uF - w.z, 1.0);
  vec2 sc = (w.xy - uEcran * 0.5) * k;
  gl_Position = vec4(sc.x / (uEcran.x * 0.5), -sc.y / (uEcran.y * 0.5), -w.z / 4000.0, 1.0);
}`;

  const FS = `
precision mediump float;
uniform sampler2D uTex;
uniform float uAvecTex, uAlpha, uEch;
uniform vec2 uTailleF;
uniform vec3 uLum;
varying vec2 vUv;
varying vec3 vN;
uniform vec4 uForme;
uniform vec3 uTab;
float smin(float a, float b, float k){ float h = clamp(0.5 + 0.5 * (b - a) / k, 0.0, 1.0); return mix(b, a, h) - k * h * (1.0 - h); }
float trapeze(vec2 p, float r1, float r2, float he){
  vec2 k1 = vec2(r2, he);
  vec2 k2 = vec2(r2 - r1, 2.0 * he);
  p.x = abs(p.x);
  vec2 ca = vec2(p.x - min(p.x, (p.y < 0.0) ? r1 : r2), abs(p.y) - he);
  vec2 cb = p - k1 + k2 * clamp(dot(k1 - p, k2) / dot(k2, k2), 0.0, 1.0);
  float s = (cb.x < 0.0 && ca.y < 0.0) ? -1.0 : 1.0;
  return s * sqrt(min(dot(ca, ca), dot(cb, cb)));
}
float forme(vec2 p){
  vec2 q = p - vec2(0.0, uForme.z);
  float xn = clamp(q.x / uForme.x, -1.0, 1.0);
  q.y -= 0.12 * uForme.y * xn * xn;
  float hh = uForme.y * (1.0 - 0.08 * xn * xn);
  float r = min(uForme.w, hh);
  vec2 d = abs(q) - vec2(uForme.x, hh) + r;
  float barre = length(max(d, 0.0)) + min(max(d.x, d.y), 0.0) - r;
  float yh = uForme.z + 0.5 * uForme.y, yb = uForme.z + uForme.y + uTab.z;
  float he = 0.5 * (yb - yh);
  float rr = uTab.y * 0.9;
  float langue = trapeze(p - vec2(0.0, 0.5 * (yh + yb)), uTab.x - rr, uTab.y - rr, he - rr) - rr;
  return smin(barre, langue, uTab.x * 0.7);
}
void main(){
  vec2 p = (vUv - 0.5) * (uTailleF / uEch);
  float sd = forme(p) * uEch;
  float bord = 1.0 - smoothstep(-1.2, 0.6, sd);
  if (bord <= 0.0) discard;
  vec3 n = normalize(vN);
  float dos = step(n.z, 0.0);
  n = mix(n, -n, dos);
  vec3 L = normalize(uLum);
  vec3 H = normalize(L + vec3(0.0, 0.0, 1.0));
  float dif = max(dot(n, L), 0.0);
  float nh = max(dot(n, H), 0.0);
  float spe = pow(nh, 60.0);
  float lustre = pow(nh, 9.0);
  vec2 tuv = vUv * vec2(uTailleF.x / uTailleF.y, 1.0) * 1.35;
  float lum = dot(texture2D(uTex, tuv).rgb, vec3(0.299, 0.587, 0.114));
  float moy = dot(texture2D(uTex, tuv, 9.0).rgb, vec3(0.299, 0.587, 0.114));
  float grain = (lum - moy) * uAvecTex;
  vec3 face = vec3(0.985, 0.978, 0.982) * (1.0 + grain * 0.75);
  vec3 envers = vec3(1.0, 0.993, 0.995) * (1.0 + grain * 0.35);
  vec3 col = mix(face, envers, dos);
  col *= 0.8 + 0.24 * dif;
  col += vec3(1.0) * (spe * 0.7 + lustre * 0.08);
  float bande = exp(-pow((vUv.x * 0.8 + vUv.y * 0.55 - 0.62) * 3.2, 2.0));
  col += vec3(1.0) * bande * 0.1 * (1.0 - dos);
  col *= 1.0 - 0.13 * smoothstep(-3.5, -0.4, sd);
  col += vec3(1.0) * 0.07 * (smoothstep(-13.0, -6.0, sd) - smoothstep(-6.0, -3.0, sd));
  col *= mix(vec3(1.0), vec3(0.97, 0.94, 0.95), smoothstep(-26.0, 0.0, sd) * 0.6);
  float a = uAlpha * bord * mix(0.8, 0.96, dos);
  a = clamp(a + spe * 0.12 * uAlpha, 0.0, 1.0);
  gl_FragColor = vec4(min(col, vec3(1.0)) * a, a);
}`;

  const VS_O = `
attribute vec2 aUv;
uniform vec2 uCentre, uTaille, uEcran;
varying vec2 vP;
void main(){
  vP = (aUv - 0.5) * uTaille;
  vec2 w = vP + uCentre;
  gl_Position = vec4(w.x / (uEcran.x * 0.5) - 1.0, 1.0 - w.y / (uEcran.y * 0.5), 0.0, 1.0);
}`;

  const FS_O = `
precision mediump float;
uniform vec2 uDir;
uniform float uL, uR, uAlpha, uEch;
varying vec2 vP;
uniform vec4 uForme;
uniform vec3 uTab;
float smin(float a, float b, float k){ float h = clamp(0.5 + 0.5 * (b - a) / k, 0.0, 1.0); return mix(b, a, h) - k * h * (1.0 - h); }
float trapeze(vec2 p, float r1, float r2, float he){
  vec2 k1 = vec2(r2, he);
  vec2 k2 = vec2(r2 - r1, 2.0 * he);
  p.x = abs(p.x);
  vec2 ca = vec2(p.x - min(p.x, (p.y < 0.0) ? r1 : r2), abs(p.y) - he);
  vec2 cb = p - k1 + k2 * clamp(dot(k1 - p, k2) / dot(k2, k2), 0.0, 1.0);
  float s = (cb.x < 0.0 && ca.y < 0.0) ? -1.0 : 1.0;
  return s * sqrt(min(dot(ca, ca), dot(cb, cb)));
}
float forme(vec2 p){
  vec2 q = p - vec2(0.0, uForme.z);
  float xn = clamp(q.x / uForme.x, -1.0, 1.0);
  q.y -= 0.12 * uForme.y * xn * xn;
  float hh = uForme.y * (1.0 - 0.08 * xn * xn);
  float r = min(uForme.w, hh);
  vec2 d = abs(q) - vec2(uForme.x, hh) + r;
  float barre = length(max(d, 0.0)) + min(max(d.x, d.y), 0.0) - r;
  float yh = uForme.z + 0.5 * uForme.y, yb = uForme.z + uForme.y + uTab.z;
  float he = 0.5 * (yb - yh);
  float rr = uTab.y * 0.9;
  float langue = trapeze(p - vec2(0.0, 0.5 * (yh + yb)), uTab.x - rr, uTab.y - rr, he - rr) - rr;
  return smin(barre, langue, uTab.x * 0.7);
}
void main(){
  float d = dot(vP, uDir) - uL;
  float o = 0.0;
  if (d > 0.0) {
    float sd = forme(vP / uEch) * uEch;
    float dans = 1.0 - smoothstep(-6.0, 3.0, sd);
    o = (0.24 * exp(-d / (uR * 1.15)) + 0.2 * exp(-d / 5.0)) * dans;
  } else {
    float sd = forme((vP - vec2(3.0, 6.0)) / uEch) * uEch;
    o = 0.16 * exp(-max(sd, 0.0) / 9.0) * (1.0 - smoothstep(-2.0, 0.0, -sd));
  }
  float a = o * uAlpha;
  gl_FragColor = vec4(vec3(0.23, 0.1, 0.18) * a, a);
}`;

  let pP, pO;
  const compile = (vs, fs) => {
    const p = gl.createProgram();
    [[gl.VERTEX_SHADER, vs], [gl.FRAGMENT_SHADER, fs]].forEach(([t, src]) => {
      const s = gl.createShader(t);
      gl.shaderSource(s, src);
      gl.compileShader(s);
      if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) throw new Error(gl.getShaderInfoLog(s) || 'shader');
      gl.attachShader(p, s);
    });
    gl.linkProgram(p);
    if (!gl.getProgramParameter(p, gl.LINK_STATUS)) throw new Error(gl.getProgramInfoLog(p) || 'link');
    return p;
  };
  const unis = (p, noms) => { const o = {}; noms.forEach((n) => { o[n] = gl.getUniformLocation(p, n); }); return o; };

  let uP, uO, aP, aO, mesh, quad;
  const grille = (nx, ny, u0, u1) => {
    const pos = [], idx = [];
    for (let j = 0; j <= ny; j++) for (let i = 0; i <= nx; i++) pos.push(u0 + (u1 - u0) * i / nx, u0 + (u1 - u0) * j / ny);
    for (let j = 0; j < ny; j++) for (let i = 0; i < nx; i++) {
      const a = j * (nx + 1) + i, b = a + 1, c = a + nx + 1, d = c + 1;
      idx.push(a, c, b, b, c, d);
    }
    const vb = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, vb);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(pos), gl.STATIC_DRAW);
    const ib = gl.createBuffer();
    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, ib);
    gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, new Uint16Array(idx), gl.STATIC_DRAW);
    return { vb, ib, n: idx.length };
  };

  try {
    pP = compile(VS, FS);
    pO = compile(VS_O, FS_O);
    uP = unis(pP, ['uCentre', 'uTaille', 'uDir', 'uEcran', 'uL', 'uR', 'uF', 'uRot', 'uDepl', 'uTex', 'uAvecTex', 'uAlpha', 'uLum', 'uTailleF', 'uEch', 'uForme', 'uTab']);
    uO = unis(pO, ['uCentre', 'uTaille', 'uEcran', 'uDir', 'uL', 'uR', 'uAlpha', 'uEch', 'uForme', 'uTab']);
    aP = gl.getAttribLocation(pP, 'aUv');
    aO = gl.getAttribLocation(pO, 'aUv');
    quad = grille(1, 1, -0.6, 1.6);
  } catch (e) { off(); return; }

  /* Grain du silicone (texture générée avec Higgsfield), répété : on la remet en 512 × 512 (puissance de 2). */
  const tex = gl.createTexture();
  let avecTex = 0;
  gl.bindTexture(gl.TEXTURE_2D, tex);
  gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, new Uint8Array([246, 208, 218, 255]));
  const src = canvas.dataset.texture;
  if (src) {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.decoding = 'async';
    img.onload = () => {
      try {
        const c = document.createElement('canvas');
        c.width = c.height = 512;
        c.getContext('2d').drawImage(img, 0, 0, 512, 512);
        gl.bindTexture(gl.TEXTURE_2D, tex);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, c);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.MIRRORED_REPEAT);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.MIRRORED_REPEAT);
        gl.generateMipmap(gl.TEXTURE_2D);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        avecTex = 1;
        demander();
      } catch (e) { avecTex = 0; }
    };
    img.src = src;
  }

  sec.classList.add('lis-p3d-on');
  sec.classList.remove('lis-p3d-off');

  let W = 1, H = 1, C = [0, 0], T = [1, 1], sMax = 0, Rb = 40, lenZ = 0, offZ = 0, dpr = 1, F = [1, 1, 0, 0], TB = [0, 0, 0];

  /* Silhouette du patch front Sérénelle (même calcul que dans le shader, en unités normalisées) */
  const smin = (a, b, k) => { const h = Math.min(1, Math.max(0, 0.5 + 0.5 * (b - a) / k)); return b + (a - b) * h - k * h * (1 - h); };
  const trapeze = (px, py, r1, r2, he) => {
    px = Math.abs(px);
    const k1x = r2, k1y = he, k2x = r2 - r1, k2y = 2 * he;
    const cax = px - Math.min(px, py < 0 ? r1 : r2), cay = Math.abs(py) - he;
    const t = Math.min(1, Math.max(0, ((k1x - px) * k2x + (k1y - py) * k2y) / (k2x * k2x + k2y * k2y)));
    const cbx = px - k1x + k2x * t, cby = py - k1y + k2y * t;
    const sg = (cbx < 0 && cay < 0) ? -1 : 1;
    return sg * Math.sqrt(Math.min(cax * cax + cay * cay, cbx * cbx + cby * cby));
  };
  const forme = (px, py) => {
    const qx = px; let qy = py - F[2];
    const xn = Math.min(1, Math.max(-1, qx / F[0]));
    qy -= 0.12 * F[1] * xn * xn;
    const hh = F[1] * (1 - 0.08 * xn * xn), r = Math.min(F[3], hh);
    const dx = Math.abs(qx) - F[0] + r, dy = Math.abs(qy) - hh + r;
    const barre = Math.hypot(Math.max(dx, 0), Math.max(dy, 0)) + Math.min(Math.max(dx, dy), 0) - r;
    const yh = F[2] + 0.5 * F[1], yb = F[2] + F[1] + TB[2], he = 0.5 * (yb - yh), rr = TB[1] * 0.9;
    const langue = trapeze(px, py - 0.5 * (yh + yb), TB[0] - rr, TB[1] - rr, he - rr) - rr;
    return smin(barre, langue, TB[0] * 0.7);
  };
  const mesurer = () => {
    const r = scene.getBoundingClientRect();
    const t = zone.getBoundingClientRect();
    W = Math.max(1, r.width); H = Math.max(1, r.height);
    dpr = Math.min(window.devicePixelRatio || 1, 2, Math.sqrt(4.2e6 / (W * H)));
    canvas.width = Math.round(W * dpr);
    canvas.height = Math.round(H * dpr);
    const padX = Math.max(16, t.width * 0.07), padY = Math.max(20, t.height * 0.14);
    /* Sur téléphone, le patch déborde de l'écran : gros plan sur le patch front, languette au centre. */
    const etroit = W < 700;
    D = etroit ? dir(-0.4, -0.92) : dir(-0.62, -0.78);
    const bw = etroit ? Math.max(t.width + padX * 2, W * 1.34) : Math.min(W - 8, t.width + padX * 2), bh = t.height + padY * 2;
    const lang = Math.min(bw * 0.11, bh * 0.5);
    T = [bw, bh + lang];
    C = [t.left - r.left + t.width / 2, t.top - r.top + t.height / 2 + lang / 2];
    const S = T[0];
    F = [bw / 2 / S, bh / 2 / S, -lang / 2 / S, Math.min(bh / 2, bw * 0.13) / S];
    TB = [Math.max(bw * 0.1, 26) / S, Math.max(bw * 0.045, 11) / S, lang / S];
    sMax = 0;
    for (let j = 0; j <= 40; j++) for (let i = 0; i <= 80; i++) {
      const x = (i / 80 - 0.5) * T[0], y = (j / 40 - 0.5) * T[1];
      if (forme(x / S, y / S) < 0) sMax = Math.max(sMax, x * D[0] + y * D[1]);
    }
    Rb = 22 + Math.min(bw, bh) * 0.11;
    lenZ = Math.abs(t.width * D[0]) + Math.abs(t.height * D[1]);
    offZ = lang / 2 * D[1];
    zone.style.setProperty('--ang', (Math.atan2(D[0], -D[1]) * 180 / Math.PI).toFixed(2) + 'deg');
    const nx = Math.min(110, Math.max(40, Math.round(T[0] / 9)));
    const ny = Math.min(110, Math.max(24, Math.round(nx * T[1] / T[0])));
    if (!mesh || mesh.nx !== nx || mesh.ny !== ny) {
      if (mesh) { gl.deleteBuffer(mesh.vb); gl.deleteBuffer(mesh.ib); }
      mesh = Object.assign(grille(nx, ny, 0, 1), { nx, ny });
    }
    demander();
  };

  const borne = (v, a, b) => Math.min(b, Math.max(a, v));
  const doux = (x) => x * x * (3 - 2 * x);
  const sortie = (x) => 1 - Math.pow(1 - x, 3);

  const lier = (buf, loc) => {
    gl.bindBuffer(gl.ARRAY_BUFFER, buf.vb);
    gl.enableVertexAttribArray(loc);
    gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, buf.ib);
  };

  const dessiner = (L, R, k, q) => {
    gl.viewport(0, 0, canvas.width, canvas.height);
    gl.clearColor(0, 0, 0, 0);
    gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
    gl.enable(gl.BLEND);
    gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
    const alpha = 1 - doux(borne((k - 0.3) / 0.7, 0, 1));
    if (alpha <= 0.002) return;

    gl.disable(gl.DEPTH_TEST);
    gl.useProgram(pO);
    lier(quad, aO);
    gl.uniform2f(uO.uCentre, C[0], C[1]);
    gl.uniform2f(uO.uTaille, T[0], T[1]);
    gl.uniform2f(uO.uEcran, W, H);
    gl.uniform2f(uO.uDir, D[0], D[1]);
    gl.uniform1f(uO.uEch, T[0]);
    gl.uniform4f(uO.uForme, F[0], F[1], F[2], F[3]);
    gl.uniform3f(uO.uTab, TB[0], TB[1], TB[2]);
    gl.uniform1f(uO.uL, L);
    gl.uniform1f(uO.uR, R);
    gl.uniform1f(uO.uAlpha, (1 - 0.95 * q * q) * (1 - borne(k * 3, 0, 1)));
    gl.drawElements(gl.TRIANGLES, quad.n, gl.UNSIGNED_SHORT, 0);

    gl.enable(gl.DEPTH_TEST);
    gl.depthFunc(gl.LEQUAL);
    gl.useProgram(pP);
    lier(mesh, aP);
    gl.activeTexture(gl.TEXTURE0);
    gl.bindTexture(gl.TEXTURE_2D, tex);
    gl.uniform1i(uP.uTex, 0);
    gl.uniform1f(uP.uAvecTex, avecTex);
    gl.uniform2f(uP.uCentre, C[0], C[1]);
    gl.uniform2f(uP.uTaille, T[0], T[1]);
    gl.uniform2f(uP.uTailleF, T[0], T[1]);
    gl.uniform2f(uP.uDir, D[0], D[1]);
    gl.uniform2f(uP.uEcran, W, H);
    gl.uniform1f(uP.uL, L);
    gl.uniform1f(uP.uR, R);
    gl.uniform1f(uP.uF, Math.max(W, H) * 1.7);
    gl.uniform1f(uP.uRot, -0.28 * k);
    gl.uniform3f(uP.uDepl, -D[0] * W * 0.45 * k, (-D[1] * W * 0.45 + H * 0.35) * k, 260 * k);
    gl.uniform1f(uP.uEch, T[0]);
    gl.uniform4f(uP.uForme, F[0], F[1], F[2], F[3]);
    gl.uniform3f(uP.uTab, TB[0], TB[1], TB[2]);
    gl.uniform1f(uP.uAlpha, alpha);
    gl.uniform3f(uP.uLum, -0.45, -0.65, 0.9);
    gl.drawElements(gl.TRIANGLES, mesh.n, gl.UNSIGNED_SHORT, 0);
  };

  let visible = false, raf = 0, dernier = '';
  const demander = () => { if (!raf) raf = requestAnimationFrame(image); };

  function image(t) {
    raf = 0;
    const r = sec.getBoundingClientRect();
    const vh = window.innerHeight || 1;
    const p = borne(-r.top / Math.max(1, r.height - vh), 0, 1);
    const x = borne((p - 0.06) / 0.64, 0, 1);
    const q = x * (0.75 + 0.25 * x);
    const k = sortie(borne((p - 0.7) / 0.18, 0, 1));
    const R = Rb * (1 + 0.75 * q);
    const sMin = -Math.abs(D[0]) * T[0] / 2 - Math.abs(D[1]) * T[1] / 2;
    let L = sMax + 2 - q * (sMax - sMin + Math.PI * R + 6);
    const repos = q === 0;
    if (repos) L = sMax - (14 + 12 * (0.5 + 0.5 * Math.sin(t / 520)));
    const cle = [p.toFixed(4), avecTex, W, H, repos ? Math.round(t / 16) : 0].join('|');
    if (cle !== dernier) {
      dernier = cle;
      dessiner(L, R, k, q);
      const seuil = k > 0 ? -1e4 : L + R * 0.55;
      zone.style.setProperty('--m', (seuil + offZ + lenZ / 2).toFixed(1) + 'px');
      sec.style.setProperty('--p', p.toFixed(3));
      sec.classList.toggle('lis-p3d-go', p > 0.02);
      sec.classList.toggle('lis-p3d-fini', p > 0.74);
    }
    if (visible) raf = requestAnimationFrame(image);
  }

  new IntersectionObserver(([e]) => {
    visible = e.isIntersecting;
    document.documentElement.classList.toggle('lis-p3d-vu', visible);
    if (visible) demander();
  }, { rootMargin: '120px 0px' }).observe(sec);

  if ('ResizeObserver' in window) new ResizeObserver(mesurer).observe(scene);
  else addEventListener('resize', mesurer);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(mesurer);
  canvas.addEventListener('webglcontextlost', (e) => { e.preventDefault(); off(); });
  mesurer();
})();
